import { defineMessages } from 'react-intl';

export default defineMessages({
  emptyCart: {
    id: 'app.desktopCart.emptyCart',
    defaultMessage: 'Tu pedido está vacío',
  },

  edit: {
    id: 'app.desktopCart.edit',
    defaultMessage: 'Editar',
  },

  accept: {
    id: 'app.desktopCart.accept',
    defaultMessage: 'Aceptar',
  },

  title: {
    id: 'app.desktopCart.title',
    defaultMessage: 'Mi pedido',
  },

  youCarrying: {
    id: 'app.desktopCart.youCarrying',
    defaultMessage: 'Estás llevando:',
  },
});
